import { FunctionComponent } from 'react';
import Card, { ContentCard } from '@ingka/card';
import AspectRatioBox from '@ingka/aspect-ratio-box';
import Image from '@ingka/image';
import { ContentPageVariant } from '@pnpmworkspace/shared-types';

const createImgSrcSet = (plannerImg: string | undefined | null): string => {
  if (plannerImg) {
    return `${plannerImg}?f=xxxl 1400w,
    ${plannerImg}?f=xxl 950w,
    ${plannerImg}?f=xl 800w,
    ${plannerImg}?f=l 750w,
    ${plannerImg}?f=m 600w,
    ${plannerImg}?f=s 500w,
    ${plannerImg}?f=xs 400w,
    ${plannerImg}?f=xxs 300w,
    ${plannerImg}?f=xxxs 240w`;
  }
  return '';
};

type BannerProps = {
  title: string;
  description: string;
  cta: string;
  image?: string;
  alt?: string;
  linkTo: string;
  imagePosition?: 'leading' | 'trailing';
  loading?: 'lazy' | 'eager';
  componentType:
    | 'planner_banner'
    | 'discover_now_banner'
    | 'learn_more_banner'
    | 'services_banner'
    | 'steps_banner';
  testId?: string;
  contentPageVariant?: ContentPageVariant;
  className?: string;
};

export const Banner: FunctionComponent<BannerProps> = (props) => {
  // Keep this for now, later on the market specific data should
  // be able to toggle if this is visible or not
  if (!props.linkTo) {
    return <></>;
  }
  const IMAGE_MEDIA_QUERY_SIZES = '(min-width: 37.5em) 40vw, 90vw';
  return (
    <Card
      className={`plann-content-page-banner ${props.className || 'w-full'}`}
      mediaPosition={props.imagePosition || 'leading'}
      media={
        props.image && (
          <AspectRatioBox ratio='16:9' data-testid={`${props.testId}-media`}>
            <Image
              alt={props.alt}
              sizes={IMAGE_MEDIA_QUERY_SIZES}
              src={props.image}
              srcSet={createImgSrcSet(props.image)}
              loading={props.loading || 'lazy'}
            />
          </AspectRatioBox>
        )
      }
      content={
        <ContentCard
          data-testid={`${props.testId}-content`}
          id={'plann-content-page-banner'}
          className={`${props.className && props.image ? 'w-full' : 'w-1/2'}`}
          body={props.description}
          buttonProps={{
            text: props.cta,
          }}
          title={props.title}
          titleHeadingTag='h2'
        />
      }
    />
  );
};
